import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl mx-auto 2xl:max-w-screen-2xl" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white capitalize" }, "Personal settings"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal mt-4 text-white" }, " Maximize the quality of your deal matches: verify that the loan criteria in your profile is complete ")
  ])
], -1)
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-9 gap-4" }
const _hoisted_3 = { class: "col-span-9 lg:col-span-3" }
const _hoisted_4 = { class: "col-span-9 lg:col-span-6 rounded-md bg-white shadow-sm px-4 py-6 sm:px-6 xl:p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_details = _resolveComponent("account-details")!
  const _component_account_contact_information = _resolveComponent("account-contact-information")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_account_details, { class: "rounded-md bg-white shadow-sm px-4 py-6 sm:px-6 xl:p-8" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_account_contact_information)
      ])
    ])
  ], 64))
}